angular.module('avant.services', []);
require('./AuthenticationService.coffee');
require('./avantErrorService.coffee');
require('./DirectDebitService.coffee');